// eslint-disable-next-line no-new-func
const uselessFunction = new Function()
export default new Proxy(console, {
  get(target, prop: keyof Console) {
    const method = target[prop]
    type Prop = typeof prop

    if (typeof method === 'function') {
      if (process.env.NODE_ENV === 'development') {
        // @ts-ignore
        const proxyMethod: Console[Prop] = (...args) => method.apply(this, args)
        return proxyMethod
      } else {
        return uselessFunction
      }
    } else {
      if (process.env.NODE_ENV === 'development') {
        return method
      } else {
        return undefined
      }
    }
  },
})
